import { render, staticRenderFns } from "./DashboardTopMenu.vue?vue&type=template&id=67f6c052&scoped=true&"
import script from "./DashboardTopMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardTopMenu.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTopMenu.vue?vue&type=style&index=0&id=67f6c052&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f6c052",
  null
  
)

export default component.exports